// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
